import React, { useEffect, useState } from "react";
import './App.css';
import { Home } from './pages/home/Home';
import { IEvent } from './models/Event';
import { AppHeader } from './components/header/AppHeader';
import {Route, Routes, useParams} from 'react-router-dom';
import { Sponsors } from './components/sponsers/Sponsors';
import { AppFooter } from './components/footer/AppFooter';
import { Details } from './pages/details/Details';
import { Contact } from './pages/contact/Contact';
import { Maps } from './pages/maps/Maps';
import { Enrollment } from './pages/enrollment/Enrollment';
import ScrollToTop from "./components/ScrollToTop";
import { Gallery } from "./pages/gallery/Gallery";
import { Info } from "./pages/info/Info";
import Favicon from "react-favicon";
import { MobileCtaBar } from "./components/mobile-cta-bar/MobileCtaBar";
import TagManager from 'react-gtm-module'
import { applyEventTheme } from "./utils/event-theme";
import { getEventDateMs } from "./utils/event-date";

function App() {
    const [event, setEvent] = useState<IEvent | any>(null)
    const [existPage, setExistPage] = useState<string>("Home")
    const {codeName} = useParams();

    const pageHeader = (pageName: string) => {
        setExistPage(pageName)
    }

    useEffect(() => {
        if(!event?.gtmId) return
        TagManager.initialize({ gtmId: event.gtmId })
    }, [event?.gtmId])

    useEffect(() => {
        getJsonFromApi().then()
    }, [])

    useEffect(() => {
        if (!event) return

        // the manifest is served from a blob: url, so every url inside it has to be absolute
        const origin = window.location.origin
        const myDynamicManifest = {
            "short_name": `${event.shortName}`,
            "name": `${event.shortName}`,
            "icons": [
                {
                    "src": `${origin}/favicon.ico`,
                    "sizes": "64x64 32x32 24x24 16x16",
                    "type": "image/x-icon"
                },
                {
                    "src": `${origin}/logo192.png`,
                    "type": "image/png",
                    "sizes": "192x192"
                },
                {
                    "src": `${origin}/logo512.png`,
                    "type": "image/png",
                    "sizes": "512x512"
                }
            ],
            "start_url": `${origin}/${codeName}`,
            "display": "standalone",
            "theme_color": event.backgroundColor,
            "background_color": "#ffffff"
        };

        const blob = new Blob([JSON.stringify(myDynamicManifest)], {type: 'application/json'});
        const manifestURL = URL.createObjectURL(blob);
        document.querySelector('#my-manifest-placeholder')?.setAttribute('href', manifestURL);
        document.title = event.description

        return () => URL.revokeObjectURL(manifestURL)
    }, [event, codeName])

    const getJsonFromApi = async () => {
        try {
            const response = await fetch(`https://www.4sport-live.com/miniSite/eventData/?codeName=${codeName}`);
            const responseJson = await response.json();
            applyEventTheme(responseJson)
            setEvent(responseJson)
            return responseJson;
        } catch (error) {
            console.error(error);
        }
    }

    if (!event) return <div className="lds-ripple">
        <div></div>
        <div></div>
    </div>


    const DATE_IN_MS = getEventDateMs(event);

    return (
        <>
            <ScrollToTop/>
            <Favicon url={event.logo}></Favicon>
            <div className="App">
                <AppHeader event={event} existPage={existPage}/>
                <main className="app-main">
                    <Routes>
                        <Route path={`/`} element={<Home event={event} pageHeader={pageHeader}/>}/>
                        <Route path={`/home`} element={<Home event={event} pageHeader={pageHeader}/>}/>
                        <Route path={`/contact`} element={<Contact event={event} pageHeader={pageHeader}/>}/>
                        <Route path={`/enrollment`} element={<Enrollment event={event} pageHeader={pageHeader}/>}/>
                        <Route path={`/details`} element={<Details target={DATE_IN_MS} event={event} pageHeader={pageHeader}/>}/>
                        {event.showMaps && <Route path={`/maps`} element={<Maps event={event} pageHeader={pageHeader}/>}/>}
                        <Route path={`/gallery`} element={<Gallery event={event} pageHeader={pageHeader}/>}/>
                        {event.customPage && <Route path={`/${event.customPage.name}`} element={<Info event={event} custom={event.customPage} pageHeader={pageHeader}/>}/>}
                    </Routes>
                </main>
                {event.sponsors && event.sponsors.length !== 0 && <Sponsors event={event}/>}
                <AppFooter event={event}/>
                <MobileCtaBar event={event} targetDate={DATE_IN_MS}/>
            </div>
        </>
    );
}

// @ts-ignore
export default App;
